import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    selectedCareer: null,
  },
  mutations: {
    setSelectedCareer(state, career) {
      state.selectedCareer = career;
    },
    clearSelectedCareer(state) {
      state.selectedCareer = null;
    },
  },
  actions: {
    setSelectedCareer({ commit }, career) {
      commit("setSelectedCareer", career);
    },
    clearSelectedCareer({ commit }) {
      commit("clearSelectedCareer");
      sessionStorage.removeItem("vuex");
    },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
});

export default store;
